import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Textarea,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import format from "date-fns/format";
import getDay from "date-fns/getDay";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import { useEffect, useState } from "react";
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-datepicker/dist/react-datepicker.css";
import AdminDashboardHeader from "../../components/admin/AdminHeader";
import AdminSidebar from "../../components/admin/AdminSidebar";
import { IAvailableCourse } from "../../models/trainee-course.model";
import { getLocalUserProfile } from "../../services/auth.service";
import calendarService from "../../services/trainer/calendar.service";
import { getNexMonth, getPreviousMonth } from "../../utils/dates";

const locales = {
  "en-US": require("date-fns/locale/en-US"),
};
const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});

const events = [
  {
    title: "NAPTIN Conference",
    allDay: true,
    start: new Date(2023, 8, 26),
    end: new Date(2023, 8, 26),
  },
  {
    title: "Conference",
    start: new Date(2023, 8, 26),
    end: new Date(2022, 8, 26),
  },
  {
    title: "Electrical Training",
    start: new Date(2023, 9, 26),
    end: new Date(2023, 9, 26),
  },
];

const AdminCalendar = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [availableCourse, setAvailableCourses] = useState<IAvailableCourse[]>();
  const [allEvents, setAllevents] = useState<any[]>();
  const [courseId, setCourseId] = useState("");
  const [user, setUser] = useState<any>();
  const [start_date, setStartDate] = useState("");
  const [end_date, setEnddate] = useState("");
  const [event_title, setEvent] = useState("");
  const [event_location, setEventLocation] = useState("");
  const [event_description, setDescription] = useState("");
  const [reload, setReload] = useState(false);
  const toast = useToast();

  const current_date = new Date().toISOString().slice(0, 16);

  useEffect(() => {
    const user = getLocalUserProfile();
    if (user) {
      setUser(user);
      const date = new Date();
      calendarService
        .getCalendar(user.id, getPreviousMonth(date), getNexMonth(date))
        .then((res) => {
          const events: any[] = [];
          res.data.forEach((each) => {
            const date = new Date(each.event_datetime);
            const year = date.getFullYear();
            const month = date.getMonth();
            const day = date.getDate();
            const hour = date.getHours();
            const minute = date.getMinutes();
            const end_date = new Date(each.event_end_datetime);
            const end_year = end_date.getFullYear();
            const end_month = end_date.getMonth();
            const end_day = end_date.getDate();
            const end_hour = end_date.getHours();
            const end_minute = end_date.getMinutes();
            const event_data: any = {
              title: each.event_location,
              start: new Date(year, month, day, hour, minute, 0),
              end: new Date(
                end_year,
                end_month,
                end_day,
                end_hour,
                end_minute,
                0
              ),
              desc: each.event_description,
            };
            events.push(event_data);
          });
          setAllevents(events);
        });
    }
  }, [reload]);

  const scheduleCalendar = async () => {
    const scheduleData = {
      initiator_id: user.id,
      recipient_id: user.id,
      event_datetime: start_date,
      event: event_title,
      event_description: event_description,
      event_end_datetime: end_date,
      event_location: event_location,
      send_reminder: true,
      status: "new",
      event_title: event_title,
    };
    try {
      const schedule_res = await calendarService.setCalendar(
        user.id,
        scheduleData
      );
      if (schedule_res) {
        setDescription("");
        setEvent("");
        setEventLocation("");
        setStartDate("");
        setEnddate("");
        onClose();
        setReload(!reload);
        toast({
          title: "Schedule Event",
          description: `${schedule_res.message}`,
          status: "success",
        });
      } else {
        toast({
          title: "Schedule Event",
          description: `${schedule_res.message}`,
          status: "error",
        });
      }
    } catch (error: any) {
      toast({
        title: "Schedule Event",
        description: `${error.response.data.message}`,
        status: "error",
      });
    }
  };

  return (
    <>
      <Flex
        minHeight={"100vh"}
        height={"auto"}
        boxSizing="border-box"
        maxWidth={"100hw"}
      >
        <Box
          width={["3.5rem", "3.5rem", "3.5rem", "20%"]}
          position="relative"
          top="0"
          left="0"
          zIndex="100"
        >
          <AdminSidebar />
        </Box>
        <Box width="100%">
          <AdminDashboardHeader />
          <Box
            pt="30px"
            px={["20px", "30px"]}
            width={"100%"}
            bg="#F9F8F8"
            height={"auto"}
            minHeight={"95vh"}
            maxHeight={"95vh"}
            overflowX={"scroll"}
            className="scroll-hidden"
          >
            <Flex
              justifyContent="space-between"
              alignItems="baseline"
              py="26px"
            >
              <Text color="#2B2B2B" fontWeight="800" fontSize="27px" pb="30px">
                Calendar
              </Text>
              <Button
                colorScheme={"red"}
                py="7px"
                px="9px"
                fontSize={12}
                onClick={onOpen}
              >
                {" "}
                Schedule Event
              </Button>
            </Flex>
            <Box width="100%">
              <Calendar
                localizer={localizer}
                events={allEvents}
                eventPropGetter={(allEvents: any) => {
                  const backgroundColor = "#EC3337";
                  const color = "white";
                  return { style: { backgroundColor, color } };
                }}
                startAccessor="start"
                endAccessor="end"
                style={{ height: 500 }}
              />
            </Box>
          </Box>
        </Box>
      </Flex>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Schedule Event</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <form action="">
              <FormControl mb="15px">
                <FormLabel fontWeight="700" color="brand.3" fontSize={13}>
                  Event Title
                </FormLabel>
                <Input
                  bg="inputText.500"
                  placeholder="Enter title"
                  value={event_title}
                  name="event_title"
                  onChange={(event) => setEvent(event.target.value)}
                  fontSize={12}
                />
              </FormControl>
              <FormControl mb="15px">
                <FormLabel fontWeight="700" color="brand.3" fontSize={13}>
                  Event Location
                </FormLabel>
                <Input
                  bg="inputText.500"
                  placeholder="Enter location"
                  value={event_location}
                  name="event_location"
                  onChange={(event) => setEventLocation(event.target.value)}
                  fontSize={12}
                />
              </FormControl>
              <FormControl mb="15px">
                <FormLabel fontWeight="700" color="#353535" fontSize={13}>
                  Event Description
                </FormLabel>
                <Textarea
                  p={4}
                  bg="inputText.500"
                  fontSize={12}
                  size="sm"
                  minH="100px"
                  name="description"
                  onChange={(event) => setDescription(event.target.value)}
                  value={event_description}
                />
              </FormControl>
              <HStack mb="15px">
                <FormControl>
                  <FormLabel fontWeight="700" color="brand.3" fontSize={13}>
                    Start Date
                  </FormLabel>
                  <Input
                    bg="inputText.500"
                    type={"datetime-local"}
                    placeholder="Enter title"
                    value={start_date}
                    min={current_date}
                    name="startdate"
                    onChange={(event) => setStartDate(event.target.value)}
                    fontSize={12}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel fontWeight="700" color="brand.3" fontSize={13}>
                    End Date
                  </FormLabel>
                  <Input
                    bg="inputText.500"
                    type={"datetime-local"}
                    placeholder="Enter title"
                    value={end_date}
                    name="enddate"
                    onChange={(event) => setEnddate(event.target.value)}
                    fontSize={12}
                  />
                </FormControl>
              </HStack>
            </form>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="red" variant="ghost" mr={3} onClick={onClose}>
              Close
            </Button>
            <Button
              size={"sm"}
              type="button"
              fontSize="12px"
              colorScheme={"red"}
              onClick={() => scheduleCalendar()}
            >
              Schedule
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
export default AdminCalendar;
